import React, { useState } from 'react';
import ArrowBack from '../Assets/arrow_back.svg';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { CaseItem } from '../../Contexts/types';
import { toast } from 'react-toastify';
import { LoadingDots } from '../utilities/Utilities';
// import dayjs from 'dayjs';


interface CaseDetailsProps {
  cases: CaseItem[];
}

const EditCaseDetails: React.FC<CaseDetailsProps> = ({ cases }) => {
  const { id } = useParams<{ id: string }>();
  const caseDetails = cases.find((caseItem) => caseItem.basicData.id === id);
  const [ status, setStatus ] = useState('')
  const [nextSitting, setNextSitting] = useState('')
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  if (!caseDetails) {
    return <div>Case not found.</div>;
  }

  const handleSubmit = async () => {
    const authToken = sessionStorage.getItem('token');
    if (!authToken) {
      console.error('No auth token found');
      return;
    }
  
    setIsLoading(true);
  
    // Dynamically build the body object
    const payload: { [key: string]: string } = {};
    if (status.trim()) payload.status = status;
    if (nextSitting.trim()) payload.nextSitting = nextSitting;
  
    // Ensure there's something to submit
    if (Object.keys(payload).length === 0) {
      toast.error('Please provide values to update.', {
        position: 'bottom-right',
      });
      setIsLoading(false);
      return;
    }
  
    try {
      const response = await fetch(`https://backend-kyw8.onrender.com/cases/${id}`, {
        method: 'PUT',
        headers: {
          "Authorization": `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      if (response.status === 200) {
        toast.success('Case details updated successfully!', {
          position: 'top-center',
        });
        navigate('/');
      } else {
        const data = await response.json();
        toast.error(`Failed to update case details: ${data.message}`, {
          position: 'bottom-right',
        });
      }
    } catch (error) {
      console.error('Error updating case details:', error);
      toast.error('Failed to update case details.', {
        position: 'bottom-right',
      });
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div>
      <div className='flex w-full'>
        <Link to={'/'}>
          <img src={ArrowBack} alt='arrow-back' />
        </Link>
        <p className='text-[#222222] text-4xl font-bold text-center w-full'>
          Case Information
        </p>
      </div>

      <div className='mt-6 flex flex-col gap-[30px]'>
        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Case Type:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails.caseType?.title}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Case Status:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails.basicData?.status}
          </p>
        </div>
        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>SUIT NUMBER:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails.basicData?.suitNumber}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Judge Name:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails.judge?.fullName}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>
            Court Assigned:
          </p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails.courtBasicData?.title}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Court Date:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails?.basicData?.nextSittingDate 
              ? new Intl.DateTimeFormat('en-US', {
                  timeZone: 'UTC',
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: true,
                }).format(new Date(Date.parse(caseDetails.basicData.nextSittingDate)))
              : 'Date not available'}
          </p>
        </div>

        <div className='flex gap-3'>
          <p className='text-[#222222] text-xl font-medium'>Parties:</p>
          <p className='text-[#222222] text-xl font-normal'>
            {caseDetails.basicData?.title}
          </p>
        </div>
        {caseDetails.casePermissions?.canEditCaseStatus && (
          <div className='mt-6 flex flex-col gap-[30px]'>
             <div className='flex gap-3'>
              <label htmlFor="caseType" className='text-[#222222] text-xl font-medium'>Set Case Status</label>
              <select
                name="caseStatus"
                id="caseStatus"
                className="vc-reg-input !w-fit !h-fit"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="" disabled>Select an option</option>
                <option value='approved'>Approved</option>
                <option value='mention'>Mention</option>
                <option value='hearing'>Hearing</option>
                <option value='trial'>Trial</option>
                <option value='final_Address'>Final Address</option>
                <option value='judgement'>Judgment</option>
                <option value='rejected'>Rejected</option>
                <option value='ruling'>Ruling</option>
                <option value='struck_out'>Struck Out</option>
                <option value='report_of_settlement'>Report of Settlement</option>
                <option value='dismissed'>Dismissed</option>
              </select>
            </div>
            <div className="flex gap-5">
              <label htmlFor="nextSitting"className='text-[#222222] text-xl font-medium'>Set date for Next Court Session</label>
              <input
                  type="datetime-local"
                  id="nextSitting"
                  value={nextSitting}
                  onChange={(e) => setNextSitting(e.target.value)}
                  className="vc-reg-input !w-fit !h-fit"
              />
            </div>
            <button
              onClick={handleSubmit}
              className="button-primary !text-white !font-semibold">
              {isLoading ? <LoadingDots /> :'Submit Changes' }
            </button>
          </div>
        )}
      </div>

    </div>
    );
};

export default EditCaseDetails;
